module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_en-2e82e18611c6696ad55bf751ea77048e.gif";